export default __webpack_public_path__ + "static/media/Oprea.2e529dcb.jpg";